import { render, staticRenderFns } from "./ChartEntidades.vue?vue&type=template&id=3d15d315&"
import script from "./ChartEntidades.vue?vue&type=script&lang=js&"
export * from "./ChartEntidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports